import { UtilityText } from '@policygenius/mortar';
import React from 'react';
import ReactModal from 'react-modal';

import Icon from 'components/Icon';

import styles from './global-loader.module.scss';

const setAppHeight = (): void => {
  const appDiv = document.getElementById('app');

  if (appDiv) {
    appDiv.style.height = '100%';
  }
};

const GlobalLoader: React.FC = () => {
  setAppHeight();

  return (
    <ReactModal
      isOpen
      overlayClassName={styles.overlay}
      className={styles.modal}
      contentLabel="loaderModal"
    >
      <div className={styles.body}>
        <Icon icon="ellipsis" height="72px" width="72px" />
        <UtilityText size="large" color="secondary">
          Loading...
        </UtilityText>
      </div>
    </ReactModal>
  );
};

export default GlobalLoader;
